import React, { FC, ReactNode, useState } from 'react';
import styles from '../styles.scss';
import { KeyboardArrowDown } from 'drift-ui';
import cx from 'classnames';

interface DropdownContainerProps {
  content: ReactNode;
  children?: ReactNode;
  initialOpen?: boolean;
  testId?: string;
}

export const DropdownContainer: FC<DropdownContainerProps> = ({ content, children, initialOpen, testId }) => {
  const [isVisible, setIsVisible] = useState(!!initialOpen);
  const chevronTestId = testId ? `contact-us-chevron-${testId}` : 'contact-us-chevron';
  const dropdownTestId = testId ? `contact-us-dropdown-${testId}` : 'contact-us-dropdown';
  const panelId = testId ? `contact-us-panel-${testId}` : 'contact-us-panel';

  const handleOnClick = () => {
    setIsVisible((prevIsVisible) => !prevIsVisible);
  };
  return (
    <div>
      <button
        className={styles.dropDownContainer}
        onClick={handleOnClick}
        aria-expanded={isVisible}
        aria-controls={panelId}
        data-testid={dropdownTestId}
      >
        <div className={styles.contentText}>{content}</div>
        <div className={styles.contentIcon}>
          <div>
            <KeyboardArrowDown
              data-testid={chevronTestId}
              data-state={isVisible ? 'open' : 'closed'}
              className={cx(styles.chevronIcon, isVisible ? styles.rotateIconOpen : styles.rotateIconClosed)}
            />
          </div>
        </div>
      </button>
      {isVisible && children != null && <div id={panelId}>{children}</div>}
    </div>
  );
};
